var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.735,
    height: 107.301,
    viewBox: "0 0 83.735 107.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#fcea81;}.c,.f{fill:#5048bf;}.d{fill:#121b45;}.e{isolation:isolate;}.f{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.g{fill:#ffb063;}.h{clip-path:url(#a);}.i{fill:#002d72;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.084,0H23.525l-.031,17.175L0,17.261l.084-5.882Z",
    transform: "translate(8.368 0) rotate(29)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13334.182 18344.926)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.868,0A41.868,41.868,0,0,1,83.735,41.868h0A41.868,41.868,0,1,1,0,41.868H0A41.868,41.868,0,0,1,41.868,0Z",
    transform: "translate(-13334.182 -18335.996)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13332.309 -18315.516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3475.854,8610.973l40.026-23.344,40.026,23.344-40.026,23.129Z",
    transform: "translate(3475.854 -8587.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3475.854,8796.342v21.4l40.255,23.354v-21.62Z",
    transform: "translate(3475.854 -8773.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-3075.426,8796.342v21.4l-40.255,23.354v-21.62Z",
    transform: "translate(3155.478 -8773.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-3365.936,8667.618l27.889-16.1,27.6,16.065-27.6,16.129Z",
    transform: "translate(3378.218 -8644.384)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3376.694,8516.712l29.04-16.971,29.04,16.971-29.04,16.816Z",
    transform: "translate(3376.694 -8499.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3376.694,8651.486v15.556l29.267,16.979V8668.3Z",
    transform: "translate(3376.694 -8634.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-3085.563,8651.486v15.556l-29.268,16.979V8668.3Z",
    transform: "translate(3143.643 -8634.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-3296.779,8557.9l20.217-11.705,20.006,11.684-20.006,11.725Z",
    transform: "translate(3305.708 -8541.003)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.974, 0.225, -0.225, 0.974, -13304.237, -18347.164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.9,17.087C3.78,16.878.25,13.027.013,8.486A7.332,7.332,0,0,1,4.15,1.147L6.816,0A7.333,7.333,0,0,0,2.678,7.339c.237,4.542,3.767,8.393,7.883,8.6a6.439,6.439,0,0,0,2.885-.507L10.78,16.58a6.4,6.4,0,0,1-2.54.515C8.126,17.1,8.011,17.093,7.9,17.087Z",
    transform: "translate(0 2.872)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.126 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 7.28,
    cy: 8.396,
    rx: 7.28,
    ry: 8.396,
    transform: "translate(0 5.752) rotate(-23.271)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.962,8.914h0l-.73-.335.548-1.2c-.21-.1-.4-.185-.581-.273l-.551,1.21-.73-.335L1.471,6.75l-.084-.039-.1-.048h0l-.06-.029L.951,6.507,0,6.072.545,5.26l.022.01c.4.19.5.232.509.235h0a.272.272,0,0,0,.082.03.285.285,0,0,0,.3-.147L2.34,3.459l.078.035a.622.622,0,0,0-.073-.04L2.97,2.076A.418.418,0,0,0,2.7,1.561c0-.01-.347-.164-.531-.244L2.525.532,3.532.995V1c.122.058.245.112.372.168l.1.042L4.55,0l.73.335L4.74,1.519l.053.023.02.009c.17.075.345.151.515.229L5.863.6l.731.335L6.043,2.147c1.093.623,1.476,1.278,1.205,2.061a1.247,1.247,0,0,1-1.189.949,1.534,1.534,0,0,1,.6.85,1.586,1.586,0,0,1-.247,1.154A1.628,1.628,0,0,1,4.5,8a5.492,5.492,0,0,1-.981-.3L2.96,8.918Zm.4-4.312L2.62,6.221l.143.067a5.344,5.344,0,0,0,1.226.454c.532.1.885-.032,1.048-.39a.707.707,0,0,0,.028-.564C4.858,5.247,4,4.878,3.539,4.68L3.358,4.6ZM4.365,2.391,3.7,3.86l.12.057a4.179,4.179,0,0,0,.988.366c.468.087.781-.038.935-.373a.669.669,0,0,0,.029-.534c-.178-.462-.877-.76-1.252-.92l-.15-.067Z",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 4.807, 11.615)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0.017, -0.017, 1, -13312.922, -18314.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.892 5.986) rotate(26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.896 18.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M5.551,0,2.885,1.147A6.436,6.436,0,0,1,0,1.653L2.666.507A6.437,6.437,0,0,0,5.551,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.873)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.15,1.147,6.816,0A7.332,7.332,0,0,0,2.679,7.339c.238,4.541,3.767,8.393,7.883,8.6L7.9,17.087C3.78,16.878.25,13.027.013,8.486A7.332,7.332,0,0,1,4.15,1.147Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.126 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 7.28,
    cy: 8.396,
    rx: 7.28,
    ry: 8.396,
    transform: "translate(0 5.752) rotate(-23.271)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.962,8.914h0l-.73-.335.548-1.2c-.21-.1-.4-.185-.581-.273l-.551,1.21-.73-.335L1.471,6.75l-.084-.039-.1-.048h0l-.06-.029L.951,6.507,0,6.072.545,5.26l.022.01c.4.19.5.232.509.235h0a.272.272,0,0,0,.082.03.285.285,0,0,0,.3-.147L2.34,3.459l.078.035a.622.622,0,0,0-.073-.04L2.97,2.076A.418.418,0,0,0,2.7,1.562c0-.01-.347-.164-.531-.244L2.525.532,3.532.995V1c.122.058.245.112.372.168l.1.042L4.55,0l.73.335L4.74,1.519l.053.023.02.009c.17.075.345.151.515.229L5.863.6l.731.335L6.043,2.147c1.093.623,1.476,1.278,1.205,2.061a1.247,1.247,0,0,1-1.189.949,1.534,1.534,0,0,1,.6.85,1.585,1.585,0,0,1-.247,1.154A1.628,1.628,0,0,1,4.5,8a5.491,5.491,0,0,1-.981-.3L2.96,8.918Zm.4-4.312L2.62,6.221l.143.067a5.345,5.345,0,0,0,1.226.454c.532.1.885-.032,1.048-.39a.707.707,0,0,0,.028-.564C4.858,5.247,4,4.878,3.539,4.68L3.358,4.6ZM4.365,2.391,3.7,3.86l.12.057a4.179,4.179,0,0,0,.988.366c.468.087.781-.038.935-.373a.668.668,0,0,0,.029-.534c-.178-.462-.877-.76-1.252-.92l-.15-.067Z",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 4.808, 11.615)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.875, -0.485, 0.485, -0.875, -13272.558, -18301.408)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.9,17.088l2.665-1.147L7.9,17.087C3.78,16.879.251,13.028.013,8.486A7.331,7.331,0,0,1,4.15,1.147L6.817,0A7.332,7.332,0,0,0,2.679,7.34c.238,4.541,3.766,8.392,7.883,8.6a6.436,6.436,0,0,0,2.885-.507L10.78,16.581A6.4,6.4,0,0,1,8.24,17.1Q8.069,17.1,7.9,17.088Z",
    transform: "translate(0 2.872)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.126 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 7.28,
    cy: 8.396,
    rx: 7.28,
    ry: 8.396,
    transform: "translate(0 5.752) rotate(-23.271)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.962,8.915h0l-.73-.335.548-1.2c-.21-.1-.4-.185-.581-.273l-.551,1.21-.73-.335L1.471,6.75l-.084-.039-.1-.048h0l-.06-.029L.951,6.507,0,6.072.545,5.26l.022.01c.4.19.5.232.509.235h0a.272.272,0,0,0,.082.03.285.285,0,0,0,.3-.147L2.34,3.459l.078.035a.621.621,0,0,0-.073-.04L2.97,2.076A.418.418,0,0,0,2.7,1.562c0-.01-.347-.164-.531-.244L2.525.532,3.532.995V1c.122.058.245.112.372.168l.1.042L4.55,0l.73.335L4.74,1.519l.053.023.02.009c.17.075.345.151.515.229L5.863.6l.731.335L6.043,2.147c1.093.623,1.476,1.278,1.205,2.061a1.247,1.247,0,0,1-1.189.949,1.534,1.534,0,0,1,.6.85,1.586,1.586,0,0,1-.247,1.154A1.628,1.628,0,0,1,4.5,8a5.493,5.493,0,0,1-.981-.3L2.96,8.918Zm.4-4.313L2.62,6.221l.143.067a5.344,5.344,0,0,0,1.226.454c.532.1.885-.032,1.048-.39a.707.707,0,0,0,.028-.564C4.858,5.247,4,4.878,3.539,4.68L3.358,4.6ZM4.365,2.391,3.7,3.86l.12.057a4.179,4.179,0,0,0,.988.366c.468.087.781-.038.935-.373a.669.669,0,0,0,.029-.534c-.178-.462-.877-.76-1.252-.92l-.15-.067Z",
    transform: "translate(15.884 12.307) rotate(149)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.eb8dbe0f78b91898097ca103e83d38fe.svg";
export { ForwardRef as ReactComponent };